import { Drawer } from "@caprikorn/dynamo-ui";
import type { FC } from "react";

import { ErrorTemplate } from "@components/ErrorTemplate/ErrorTemplate";
import { useGetTechnicalRequest } from "@services/apiEcms/useGetTechnicalRequest";
import { useCustomTranslation } from "@utils/translations/useCustomTranslation";

import classes from "./TicketDrawer.module.css";
import type { TicketPageDrawerProps } from "./TicketDrawer.types";

export const TicketDrawer: FC<TicketPageDrawerProps> = ({
  ticketId,
  onClose,
}) => {
  const { data, isError, isLoading } = useGetTechnicalRequest(ticketId);
  const { t } = useCustomTranslation(["main", "common"]);

  return (
    <Drawer onClose={onClose}>
      <Drawer.Header title={t("ticket.drawerTitle")} />
      <Drawer.Body isLoading={isLoading}>
        {data && (
          <div
            className={classes.wrapper}
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: data }}
            data-testid="TicketDrawerWrapper"
          />
        )}

        {isError && (
          <ErrorTemplate title={t("errors.data", { ns: "common" })} />
        )}
      </Drawer.Body>
    </Drawer>
  );
};
